export default __webpack_public_path__ + "static/clustersetup1-c569e8ddd2040e05fbd232ffdca2375b.png";